import { create } from 'zustand';
import {
  createBusinessConectionSlice,
  createBusinessProfileSlice,
  createBackdropLoaderSlice,
  BusinessConnectionsSlice,
  createPerformanceSlice,
  createQuickSetupSlice,
  createAsyncDataFetchSlice,
  createLayoutslice,
  createDialogSlice,
  createTrialSlice,
  createPromoCodeSlice,
  BusinessProfileSlice,
  BackdropLoaderSlice,
  PerformanceSlice,
  QuickSetupSlice,
  AsyncDataFetchSlice,
  LayoutSlice,
  DialogSlice,
  TrialSlice,
  PromoCodeSlice,
  UserSlice,
  createUserSlice,
  DynamicSegmentStore,
  createDynamicSegmentStore,
  createAdminSelectedBusinessSlice,
  AdminSelectedBusinessSlice,
  createUnauthorizedCallSlice,
  UnauthorizedCallSlice,
  SnackBarSlice,
  createSnackBarSlice,
  AudienceStateSlice,
  createAudienceStore,
  BasicDetailSlice,
  createBasicDetailSlice,
} from './slices';
import {createLinkTrackingSlice, LinkTrackingSlice} from "@store/slices/linkTrackingSlice";

export const useBoundStore = create<
  BusinessConnectionsSlice &
    BusinessProfileSlice &
    BackdropLoaderSlice &
    PerformanceSlice &
    QuickSetupSlice &
    AsyncDataFetchSlice &
    DialogSlice &
    TrialSlice &
    PromoCodeSlice &
    UserSlice &
    DynamicSegmentStore &
    LayoutSlice &
    AdminSelectedBusinessSlice &
    UnauthorizedCallSlice &
    SnackBarSlice &
    AudienceStateSlice &
    BasicDetailSlice &
    LinkTrackingSlice
>()((...a) => ({
  ...createBusinessProfileSlice(...a),
  ...createBusinessConectionSlice(...a),
  ...createBackdropLoaderSlice(...a),
  ...createPerformanceSlice(...a),
  ...createQuickSetupSlice(...a),
  ...createAsyncDataFetchSlice(...a),
  ...createLayoutslice(...a),
  ...createDialogSlice(...a),
  ...createTrialSlice(...a),
  ...createPromoCodeSlice(...a),
  ...createUserSlice(...a),
  ...createDynamicSegmentStore(...a),
  ...createAudienceStore(...a),
  ...createAdminSelectedBusinessSlice(...a),
  ...createUnauthorizedCallSlice(...a),
  ...createSnackBarSlice(...a),
  ...createBasicDetailSlice(...a),
  ...createLinkTrackingSlice(...a),
}));
